<template>
  <div v-show="homeScreenStatus" class="home">
    <Subject name="math" />
    <img
      v-show="!instructions"
      class="button"
      src="@/assets/practices/saving_money/button_start.svg"
      alt="start"
      @click="runInstructions"
    />
    <img
      v-show="instructions && instructionsPage !== 3"
      class="button"
      src="@/assets/practices/saving_money/button_next.svg"
      alt="next"
      @click="nextInstructions"
    />
    <img
      v-show="instructionsPage === 3"
      class="button"
      src="@/assets/practices/saving_money/button_start.svg"
      alt="start"
      @click="startGame"
    />
    <div v-show="!instructions" id="pig-home"></div>

    <div v-show="!instructions" class="sliders">
      <div id="front"></div>
      <div id="front-shadow"></div>
      <div id="mid"></div>
      <div id="mid-shadow"></div>
      <div id="back"></div>
      <div id="back-shadow"></div>
      <img id="bubble" src="@/assets/practices/saving_money/sidebar_bubble.svg" alt="bubble" />
      <h1 class="title">Saving Money</h1>
    </div>

    <div v-if="instructions" class="instructions">
      <Slider :page-one-is-open="pageOneIsOpen" :page-two-is-open="pageTwoIsOpen">
        <template v-if="instructionsPage === 0" v-slot:first-page>
          <div class="text">
            <h1 class="title">Instructions</h1>
            <p>Let's play to save money! Notice the characteristics of each coin:</p>
            <p class="special">
              <span style="color: #ff585e;">Color</span> - <span style="color: #d9ff58;">Size</span> -
              <span style="color: #b758ff;">Value</span>
            </p>
            <p>You will learn to count money easily. Let's have fun saving!</p>
          </div>
        </template>
        <template v-else-if="instructionsPage === 1" v-slot:first-page>
          <div class="text">
            <h1 class="title">Instructions</h1>
            <p>
              Insert in each pig the amount of coins by selecting each coin and dragging it to the corresponding little
              pig.
            </p>
          </div>
        </template>
        <template v-else v-slot:first-page>
          <div class="text">
            <h2 class="title">Instructions</h2>
            <p>Know the value of each currency below:</p>
            <div id="coins-simple">
              <CoinSimple name="Penny" type="penny" value="1 ¢" />
              <CoinSimple name="Nickel" type="nickel" value="5 ¢" />
              <CoinSimple name="Dime" type="dime" value="10 ¢" />
              <CoinSimple name="Quarter" type="quarter" value="25 ¢" />
            </div>
          </div>
        </template>
        <template v-show="instructions" v-slot:second-page>
          <div class="text">
            <h2 class="title">Example</h2>
            <p class="question">Insert in each little pig the number of coins requested: 5 pennies and 2 dimes.</p>
          </div>
          <Demo />
        </template>
      </Slider>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
// import { Howl } from 'howler';
import lottie from 'lottie-web/build/player/lottie';
import sounds from '@/packages/sounds/index.js';

export default {
  name: 'Home',
  components: {
    Demo: () => import('@/components/practices/saving_money/Demo.vue'),
    // Coin: () => import('@/components/practices/saving_money/Coin.vue'),
    CoinSimple: () => import('@/components/practices/saving_money/CoinSimple.vue'),
    // Pig: () => import('@/components/practices/saving_money/Pig.vue'),
    Slider: () => import('@/components/practices/saving_money/Slider.vue'),
    Subject: () => import('@/components/practices/Subject.vue'),
  },
  data: () => ({
    animationActive: false,
    instructions: false,
    instructionsPage: 0,
    pageOneIsOpen: true,
    pageTwoIsOpen: true,
    coinCount: [
      {
        pennies: 5,
        nickels: 0,
        dimes: 0,
        quarters: 0,
      },
      {
        pennies: 0,
        nickels: 0,
        dimes: 2,
        quarters: 0,
      },
    ],
  }),
  computed: {
    ...mapGetters({
      homeScreenStatus: 'savingMoney/homeScreenStatus',
    }),
  },
  mounted() {
    lottie.loadAnimation({
      container: document.getElementById('pig-home'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/assets/practices/saving_money/animations/pig.json',
    });
  },
  methods: {
    ...mapActions({
      homeClickStart: 'savingMoney/homeClickStart',
    }),
    nextInstructions() {
      sounds.globalButton.play();
      if (this.animationActive) {
        this.animationActive = true;
      } else {
        if (this.instructionsPage <= 1) {
          this.pageOneIsOpen = false;
          this.pageTwoIsOpen = false;
          setTimeout(() => {
            this.instructionsPage += 1;
            this.pageOneIsOpen = true;
            this.pageTwoIsOpen = true;
            this.animationActive = false;
          }, 2000);
        }
        if (this.instructionsPage === 2) {
          this.pageOneIsOpen = false;
          this.animationActive = false;
          this.instructionsPage += 1;
        }
      }
    },
    resetLocalData() {
      this.animationActive = false;
      this.instructions = false;
      this.instructionsPage = 0;
      this.pageOneIsOpen = true;
      this.pageTwoIsOpen = true;
    },
    runInstructions() {
      sounds.globalButton.play();
      this.instructions = true;
    },
    startGame() {
      sounds.globalButton.play();
      this.pageOneIsOpen = false;
      this.pageTwoIsOpen = false;
      setTimeout(() => {
        this.resetLocalData();
        this.homeClickStart();
      }, 2000);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.home {
  @include flex-center;
  height: 100vh;
  position: absolute;
  width: 100vw;

  .button {
    bottom: 2vh;
    cursor: pointer;
    margin: 0.25em 0;
    height: 9vh;
    position: absolute;
    right: 2vw;
    z-index: 2;
  }

  #pig-home {
    height: 75vh;
    position: absolute;
    // right: vw;
    transform: translate(12vw, 0);
    width: 75vh;
  }
}

// Sliders
.sliders {
  @include flex-center;
  color: $saving-money-color-text-title;
  flex-direction: column;
  height: 100vh;
  left: 0;
  position: absolute;
  text-align: center;
  width: 45vh;
  z-index: 2;

  .title {
    z-index: 10;
  }

  #front,
  #front-shadow,
  #mid,
  #mid-shadow,
  #back,
  #back-shadow {
    height: 100%;
    position: absolute;
    width: 100%;

    &:before {
      border-style: solid;
      border-width: 100vh 7.5vh 0px 0px;
      content: '';
      position: absolute;
      right: -7.5vh;
      top: 0px;
      transform: translate(-1px, 0);
      z-index: 1;
    }
  }

  @mixin slider-properties($backgroundId, $backgroundColor, $leftPosition, $zIndex) {
    ##{$backgroundId} {
      background-color: #{$backgroundColor};
      left: #{$leftPosition};
      z-index: #{$zIndex};

      &:before {
        border-color: #{$backgroundColor} transparent #{$backgroundColor} transparent;
      }
    }
  }

  @include slider-properties(front, #48b7d4, 0vh, 5);
  @include slider-properties(front-shadow, #40a0b8, 1vh, 4);
  @include slider-properties(mid, #48d4c0, 3vh, 3);
  @include slider-properties(mid-shadow, #41c0ad, 4vh, 2);
  @include slider-properties(back, #61c69b, 6vh, 1);
  @include slider-properties(back-shadow, #58b38b, 7vh, 0);

  #bubble {
    bottom: -20vh;
    right: 0;
    position: absolute;
    width: 70vh;
    z-index: 10;
  }
}

.instructions {
  @include flex-center;
  height: 100vh;
  position: absolute;
  width: 100vw;

  .text {
    position: absolute;
    top: 7.5vh;
    width: 90%;

    .title {
      color: $saving-money-color-text-heading;
      margin-bottom: 0.5em;
      text-align: center;
    }

    p {
      line-height: 1.75;
      margin-bottom: 1em;
    }

    .special {
      color: #5864ff;
      font-size: 1.25em;
      text-align: center;
    }
  }

  .button {
    cursor: pointer;
    margin: 0.25em 0;
    height: 9vh;
  }

  .coins,
  .pigs,
  .buttons {
    @include flex-center;
    position: absolute;
  }

  .coins {
    flex-direction: row;
  }

  #coins-simple {
    @include flex-center;
    flex-wrap: wrap;
  }

  .pigs {
    bottom: 2vh;
    flex-direction: row;
  }
}

@media (max-aspect-ratio: 8/5) {
  .home {
    #pig-home {
      height: 65vh;
      position: absolute;
      right: 5vw;
      transform: translate(0, 0);
      width: 65vh;
    }

    .text {
      font-size: 0.8em;
    }

    .pigs {
      bottom: 10vh;
      flex-direction: row;
    }

    .button {
      height: 8vh;
    }
  }
}
</style>
